module.exports = __webpack_public_path__ + "img/Analysis_data_none.c2c7a51e.png";